// extracted by mini-css-extract-plugin
export default {"main_layout":"Login_main_layout__Gr8Lk","login_form":"Login_login_form__lB-DV","layout_login_left":"Login_layout_login_left__a3fWy","btn_login":"Login_btn_login__E8gze"};